<template>
  <qtm-autocomplete v-bind="$attrs" item-title="name" item-value="isoCode" :items="countries" />
</template>

<script setup lang="ts">
import { Country } from 'country-state-city'

const countries = Country.getAllCountries()
</script>
